import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: 'maxLength'})
export class MaxLengthPipe implements PipeTransform  {
  transform(value:string, length=28):string {
    return value.length > length ? value.substring(0, length-3) + '...' : value;
  }
}